import { LoadableAfterPaint } from '@confluence/loadable';

export const UnreadCommentCount = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UnreadCommentCount" */ '../src/UnreadCommentCount.tsx'
			)
		).UnreadCommentCount,
});
